import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta06PegarEnum {
  TENTA_ALCANCAR = 'TENTA_ALCANCAR',
  LEVA_ATE = 'LEVA_ATE',
  TENTA_PEGAR = 'TENTA_PEGAR',
  PEDE = 'PEDE',
}

export interface ConsultaSeguimentoPergunta06Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_06_HEADER?: SimNaoEnum
  PERGUNTA_06_PEGAR?: Record<ConsultaSeguimentoPergunta06PegarEnum, SimNaoEnum>
  PERGUNTA_06_APONTAR_PARA?: SimNaoEnum
}
